import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Radio, ArrowLeft } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Helmet } from "react-helmet-async";
import termsText from "@/content/terms.txt?raw";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Terms of Service - EchoCRM | AI-Powered CRM</title>
        <meta name="description" content="Read EchoCRM's Terms of Service. Understand the terms and conditions for using our AI-powered CRM platform for sales professionals." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://echocrm.app/terms" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <header className="border-b border-border/50 backdrop-blur-sm bg-background/80 sticky top-0 z-50">
          <nav className="container mx-auto px-4 sm:px-6 py-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <Radio className="h-6 w-6 sm:h-8 sm:w-8 text-primary" />
                <span className="text-xl sm:text-2xl font-bold">EchoCRM</span>
              </div>
              <div className="flex gap-2 sm:gap-4 items-center">
                <ThemeToggle />
                <Button variant="ghost" size="sm" onClick={() => navigate("/")}>Home</Button>
                <Button variant="ghost" size="sm" onClick={() => navigate("/pricing")}>Pricing</Button>
                <Button variant="ghost" size="sm" onClick={() => navigate("/login")}>Sign In</Button>
              </div>
            </div>
          </nav>
        </header>

        <main className="container mx-auto px-4 sm:px-6 py-12">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className="mb-6">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>

          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold mb-2">Terms of Service</h1>
            <p className="text-sm text-muted-foreground mb-8">Effective Date: June 10, 2026</p>

            <pre className="whitespace-pre-wrap font-mono text-xs sm:text-sm text-foreground/90 leading-relaxed break-words">
{termsText}
            </pre>
          </div>
        </main>
      </div>
    </>
  );
};

export default Terms;
